module.exports = __webpack_public_path__ + "img/cert2.021bef7e.png";